export default __webpack_public_path__ + "static/userexperience-60ee9c2b6c2251a006f0a9435f244a46.svg";